<template>
  <div>
    <table v-if="kObject">
      <tr>
        <td class="col1Min">
          <div class="overline">Corneal Curvature</div>
          {{ prettyFullKstringDiopters(kObject) }}<br />

          {{ prettyFullKstringMM(kObject) }}
        </td>
        <td style="padding-top: 25px">
          <optical-cross-image
            :dimensions="75"
            :obj="kObject"
            type="keratometry"
            class=""
            style="margin-top: -15px"
            :showHeatmap="true"
          />
        </td>
      </tr>
    </table>
    <div class="overline">Nerdy Details</div>
    <table v-if="kObject">
      <!-- <tr>
        <th>Cyl Type</th>
        <td>{{ cylType(kObject) }}</td>
      </tr> -->
      <tr>
        <th>Corneal Cyl</th>
        <td>
          {{ numToDiopterString(cornealCyl(kObject)) }} {{ cylType(kObject) }}
        </td>
        <td></td>
      </tr>
      <tr>
        <th>Steep K</th>
        <td>
          {{ prettyKstringDiopters(steepK(kObject)) }} @
          {{ numToAxisString(steepKmeridian(kObject)) }}&deg;
        </td>
        <td>
          <span class="caption ml-3"
            >( {{ prettyKstringMM(steepK(kObject)) }} @
            {{ numToAxisString(steepKmeridian(kObject)) }}&deg;)</span
          >
        </td>
      </tr>
      <tr>
        <th>Flat K</th>
        <td>
          {{ prettyKstringDiopters(flatK(kObject)) }} @
          {{ numToAxisString(flatKmeridian(kObject)) }}&deg;
        </td>
        <td>
          <span class="caption ml-3"
            >( {{ prettyKstringMM(flatK(kObject)) }} @
            {{ numToAxisString(flatKmeridian(kObject)) }}&deg;)</span
          >
        </td>
      </tr>
      <tr>
        <th>Mid K</th>
        <td>
          {{ prettyKstringDiopters(midK(kObject)) }}
        </td>
        <td>
          <span class="caption ml-3"
            >({{ prettyKstringMM(midK(kObject)) }})</span
          >
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
// import Name from "../dir/file";
import RxMethods from "@/assets/js/cls/RxMethods";
import StyleUtilities from "@/assets/js/StyleUtilities";

export default {
  name: "KInformation",
  components: {
    OpticalCrossImage: () => import("@/components/clStuff/OpticalCrossImage"),
  },
  mixins: [RxMethods, StyleUtilities],
  props: {
    kObject: null,
  },
  data: function () {
    return {};
  },
  methods: {},
  computed: {},
};
</script>

<style scoped>
.col1Min {
  min-width: 175px;
}
th,
td {
  padding: 0 5px;
  text-align: left;
}
</style>
